// src/pages/TownPlanningDashboard.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../styles/TownPlanningDashboard.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUniversity,
  faFileSignature,
  faBullhorn,
  faFileAlt,
  faEnvelopeOpenText,
  faBalanceScale,
  faLandmark,
  faFile,
  faBars,
  faFilter,
  faRobot,
  faSearch,
  faCalculator,
  faBook,
  faNewspaper,
  faUserGraduate,
} from "@fortawesome/free-solid-svg-icons";
import homeIMG from "../assets/town_planner_final.png";
import TownPlanningSidebar from "../components/TownPlanningSidebar";
import FilterPopup from "../components/FilterPopup";
import { useAppContext } from "../context";
import ChatbotPanel from "../components/ChatbotPanel"; // ⬅️ Add at top
import { faComments } from "@fortawesome/free-solid-svg-icons"; // ⬅️ Add icon import
export default function TownPlanningDashboard() {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  //const { setSelectedCategory, setSearchText } = useAppContext(); // ✅ use context
    const { selectedCategory, searchText, setSearchText, filter, setFilter, setSelectedCategory } = useAppContext();
  
  const [searchTerm, setSearchTerm] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [showChatbot, setShowChatbot] = useState(false);

  const handleCardClick = (category) => {
     setFilter({
    mainCategory: "",
    subCategory: "",
    subSubCategory: "",
  });
    setSelectedCategory(category);
        setSearchText(""); // clear any old search

    navigate("/documents");
  };

  const handleCalculatorClick = () => {
    navigate("/area-convertor");
  };

  // ✅ handle search button click
  const handleSearch = () => {
    if (searchTerm.trim() !== "") {
      setSelectedCategory(null); // show all categories in DocumentList
      setSearchText(searchTerm); // pass entered text to context
      navigate("/documents"); // redirect to DocumentList
    }
  };

  return (
    <div className={styles.homeScreenContainer}>
      {/* Top Navbar */}
      <div className={styles.homeScreenHeader}>
        <button onClick={() => setIsSidebarOpen(true)} className={styles.homeScreenMenuBtn}>
          <FontAwesomeIcon icon={faBars} />
        </button>
        <TownPlanningSidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
        <div className={styles.homeScreenLogoSection}>
          <img src={homeIMG} alt="Town Planning Helpline" className={styles.homeScreenLogoImage} />
        </div>
      </div>

      {/* Search Bar */}
      <div className={styles.homeScreenSearchContainer}>
        <input
          type="text"
          placeholder="Search By Name or Date"
          className={styles.homeScreenSearchInput}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button className={styles.homeScreenSearchButton} onClick={handleSearch}>
          <FontAwesomeIcon icon={faSearch} />
        </button>
      </div>

      {/* Grid of Categories */}
      <div className={styles.homeScreenIconGrid}>
        <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("Act")}>
          <FontAwesomeIcon icon={faUniversity} className={styles.homeScreenIcon} />
          <p>Acts</p>
        </div>
        <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("Rule")}>
          <FontAwesomeIcon icon={faFileSignature} className={styles.homeScreenIcon} />
          <p>Rules</p>
        </div>
        <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("Directive")}>
          <FontAwesomeIcon icon={faBullhorn} className={styles.homeScreenIcon} />
          <p>Directives</p>
        </div>

        <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("GR")}>
          <FontAwesomeIcon icon={faFileAlt} className={styles.homeScreenIcon} />
          <p>GR</p>
        </div>
        <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("Circulars")}>
          <FontAwesomeIcon icon={faEnvelopeOpenText} className={styles.homeScreenIcon} />
          <p>Circular</p>
        </div>
        <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("Landmark Judgement / Orders")}>
          <FontAwesomeIcon icon={faBalanceScale} className={styles.homeScreenIcon} />
          <p>Courts</p>
        </div>

        <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("Government Scheme and Policy")}>
          <FontAwesomeIcon icon={faLandmark} className={styles.homeScreenIcon} />
          <p>Schemes</p>
        </div>
        <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("Formats")}>
          <FontAwesomeIcon icon={faFile} className={styles.homeScreenIcon} />
          <p>Formats</p>
        </div>
        <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("Books")}>
          <FontAwesomeIcon icon={faBook} className={styles.homeScreenIcon} />
          <p>Books</p>
        </div>

        <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("Articles")}>
          <FontAwesomeIcon icon={faNewspaper} className={styles.homeScreenIcon} />
          <p>Articles</p>
        </div>
        <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("TP Career")}>
          <FontAwesomeIcon icon={faUserGraduate} className={styles.homeScreenIcon} />
          <p>TP Career</p>
        </div>
        <div className={styles.homeScreenIconCard} onClick={handleCalculatorClick}>
          <FontAwesomeIcon icon={faCalculator} className={styles.homeScreenIcon} />
          <p>Calculator</p>
        </div>

      </div>

      {/* Floating Buttons */}
      <button
        className={`${styles.homeScreenFloatingBtn} ${styles.homeScreenFilterBtn}`}
        onClick={() => setShowFilter(true)}
      >
        <FontAwesomeIcon icon={faFilter} />
      </button>


      <button
        className={`${styles.homeScreenFloatingBtn} ${styles.homeScreenChatBtn}`}
        onClick={() => setShowChatbot((prev) => !prev)}
      >
        <FontAwesomeIcon icon={faComments} />
      </button>

      {showChatbot && <ChatbotPanel onClose={() => setShowChatbot(false)} />}

      {showFilter && <FilterPopup onClose={() => setShowFilter(false)} />}
    </div>
  );
}
